// директива для клика вне блока v-click-outside
export default {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };

    setTimeout(() => {
      document.body.addEventListener("click", el.clickOutsideEvent);
    }, 200)
  },
  unbind: function (el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
};
